import styled from "@emotion/styled";

type LineProps = {
  $width: string;
};
export const Line = styled.div<LineProps>`
  inline-size: ${props => props.$width};
  block-size: 19px;

  background: #dddddd;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  padding: 20px;

  border-radius: 8px;

  background: #ffffff;

  outline: 1px solid #cccccc;
`;
